import { createAction } from '@reduxjs/toolkit';
import eventProvider from '../../event/eventProvider';

/* eslint-disable no-unused-vars */
enum ActionType {
  ALARM_RECORD = 'ALARM_RECORD',
  ERROR_RECORD = 'ERROR_RECORD',
  JIRA_RECORD = 'JIRA_RECORD',
  CLEAR_ALARM_RECORD = 'CLEAR_ALARM_RECORD',
  SEMI_GENERATE_JIRA_ISSUE = 'SEMI_GENERATE_JIRA_ISSUE',
  JIRA_RECORD_DECORATE = 'JIRA_RECORD_DECORATE',
  ISSUE_LIST = 'ISSUE_LIST',
  ACCIDENT_MANAGE = 'ACCIDENT_MANAGE',
  PROBLEM_REPORT = 'PROBLEM_REPORT',
  COCKPIT_DATA = 'COCKPIT_DATA',
  COCKPIT_TEAM_DATA = 'COCKPIT_TEAM_DATA',
  TECH_SUPPORT_DATA = 'TECH_SUPPORT_DATA',
}

export const actionSubmitJIRAIssue = createAction<any>(
  eventProvider.makeResponseType(ActionType.SEMI_GENERATE_JIRA_ISSUE),
);

export const actionJIRARecordUpdate = createAction<any>(
  eventProvider.makeResponseType(ActionType.JIRA_RECORD_DECORATE),
);

export const actionClearAlarmRecordList = createAction(
  ActionType.CLEAR_ALARM_RECORD,
);

export default ActionType;
